import React from "react";
import "@/App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import ScrollProgress from "./components/ScrollProgress";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import Process from "./components/Process";
import Stack from "./components/Stack";
import Work from "./components/Work";
import WhyUs from "./components/WhyUs";
import FAQ from "./components/FAQ";
import CTABanner from "./components/CTABanner";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white text-brand-ink font-sans antialiased">
        <ScrollProgress />
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Process />
          <Stack />
          <Work />
          <WhyUs />
          <FAQ />
          <CTABanner />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
